import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=58684169&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Shipping.vue?vue&type=style&index=0&id=58684169&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "58684169",
  "5b6eabf8"
  
)

export default component.exports